import { AccredibleResponsiveMenuItem } from '@accredible-frontend-v2/components/responsive-menu';
import { CustomHeaderLink } from '@accredible-frontend-v2/models';
import { AccredibleLanguageService } from '@accredible-frontend-v2/services/language';
import { Component } from '@angular/core';
import { ThemeHelper } from '@spotlight/domain';

const TRANSLATION_PREFIX = 'directory_naturallifemanship_com.header';

@Component({
  templateUrl: './header.component.html',
  styleUrls: [`./header.component.scss`],
})
export class HeaderComponent {
  extraHeaderLinks: AccredibleResponsiveMenuItem[] = [
    {
      label: this._languageService.translate(`${TRANSLATION_PREFIX}.menu.about`),
      externalLink: 'https://naturallifemanship.com/about-natural-lifemanship/',
    },
    {
      label: this._languageService.translate(`${TRANSLATION_PREFIX}.menu.offerings`),
      externalLink: 'https://naturallifemanship.com/what-we-offer/',
    },
    {
      label: this._languageService.translate(`${TRANSLATION_PREFIX}.menu.trainings`),
      externalLink: 'https://naturallifemanship.com/trainings/',
    },
    {
      label: this._languageService.translate(`${TRANSLATION_PREFIX}.menu.contact`),
      externalLink: 'https://naturallifemanship.com/contact/',
    },
  ];

  startJourneyLink: AccredibleResponsiveMenuItem = {
    label: this._languageService.translate(`${TRANSLATION_PREFIX}.menu.start_journey`),
    externalLink: 'https://naturallifemanship.com/find-your-path/',
    itemClass: 'start-journey-link',
  };

  private _themeHeaderConfig: { customHeaderLinks: CustomHeaderLink[] };
  private readonly _themeName = ThemeHelper.getTheme();

  constructor(private readonly _languageService: AccredibleLanguageService) {}
}
